import { Component, Input, ViewEncapsulation } from '@angular/core';

import { ModalService } from '../../core/services/modal.service';

export const LoyaltyProgramModalPageIdentifier = 'loyalty-program-modal';

@Component({
  selector: 'app-loyalty-program-modal',
  templateUrl: './loyalty-program-modal.page.html',
  styleUrls: ['./loyalty-program-modal.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoyaltyProgramModalPage {
  @Input() public headerImageUrl: string;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public descriptionAdditionalContent: Array<{ text: string; handler: () => void }> = [];
  @Input() public titleCentered = true;
  @Input() public descriptionCentered = true;
  @Input() public addLinkToGeneralTermsAndConditions: boolean;

  constructor(private modalService: ModalService) {}

  public onHandleAdditionalContentClick(index: number): void {
    if (this.descriptionAdditionalContent && this.descriptionAdditionalContent[index] && this.descriptionAdditionalContent[index].handler) {
      this.descriptionAdditionalContent[index].handler();
      void this.dismiss(true);
    }
  }

  public onDismiss(): void {
    void this.dismiss(false);
  }

  private dismiss(result: boolean): Promise<boolean> {
    return this.modalService.dismissModal({ data: result, id: LoyaltyProgramModalPageIdentifier });
  }
}
